// component
import { ROLE } from '../../Services/auth.service';
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    title: 'Booking',
    titleEn: 'Booking',
    path: 'booking',
    icon: getIcon('uil:calender'),
    roles: [ROLE.Admin, ROLE.Manager],
  },
  {
    title: 'Tài khoản',
    titleEn: 'user',
    path: '/user',
    icon: getIcon('eva:people-fill'),
    roles: [ROLE.Admin],
  },
  {
    title: 'Khách hàng',
    titleEn: 'Customer',
    path: '/customer',
    icon: getIcon('raphael:customer'),
    roles: [ROLE.Admin, ROLE.CSKH],
  },
  {
    title: 'Khuyến mãi',
    titleEn: 'Promotion',
    path: 'promotion',
    icon: getIcon('ps:sale-tag'),
    roles: [ROLE.Admin, ROLE.Manager, ROLE.Employee],
  },
  {
    title: 'Concept',
    titleEn: 'Concept',
    path: 'concept',
    icon: getIcon('carbon:concept'),
    roles: [ROLE.Admin, ROLE.Manager],
  },
  {
    title: 'Tuyển dụng',
    titleEn: 'Recruit',
    path: 'recruit',
    icon: getIcon('akar-icons:person-add'),
    roles: [ROLE.Admin, ROLE.Recruit],
  },
  {
    title: 'Thực đơn ',
    titleEn: 'Menu',
    path: 'menu',
    icon: getIcon('akar-icons:book'),
    roles: [ROLE.Admin, ROLE.Employee],
  },
  {
    title: 'Cửa hàng',
    titleEn: 'Store',
    path: 'store',
    icon: getIcon('bxs:store-alt'),
    roles: [ROLE.Admin, ROLE.Manager],
  },
  {
    title: 'Config',
    titleEn: 'Config',
    path: 'config',
    icon: getIcon('vscode-icons:file-type-light-config'),
    roles: [ROLE.Admin],
  },
  {
    title: 'Landing',
    titleEn: 'Landing',
    path: 'landing',
    icon: getIcon('material-symbols:insert-page-break'),
    roles: [ROLE.Admin],
  },
  {
    title: 'Ads',
    titleEn: 'Ads',
    path: 'ctkm',
    icon: getIcon('mdi:ads'),
    roles: [ROLE.Admin, ROLE.Employee],
  },
  {
    title: 'Banner',
    titleEn: 'Banner',
    path: 'banner',
    icon: getIcon('ph:flag-banner'),
    roles: [ROLE.Admin, ROLE.Employee],
  },
  {
    title: 'Notes',
    titleEn: 'Notes',
    path: 'notes',
    icon: getIcon('material-symbols:add-notes'),
    roles: [ROLE.Admin, ROLE.Manager, ROLE.Employee],
  },
  {
    title: 'Thẻ thành viên',
    titleEn: 'Thẻ thành viên',
    path: 'member',
    icon: getIcon('icon-park-outline:light-member'),
    roles: [ROLE.Admin],
  },
];

export default navConfig;
